import { http, HttpResponse } from "msw";

import { loginResponseMock, userMock } from "./auth.mocks";

export const authHandlers = [
	http.post("api/login", () => {
		return HttpResponse.json(loginResponseMock, { status: 200 });
	}),
	http.get("api/me", () => {
		return HttpResponse.json(userMock, { status: 200 });
	}),
	http.post("api/reset-password", () => {
		return HttpResponse.json(null, { status: 200 });
	}),
	http.post("api/set-password", () => {
		return HttpResponse.json(null, { status: 200 });
	}),
];
